export interface INodePropCfg {
  name: string;
  type: 'string' | 'number';
}

/**
 * 获取dom节点的 属性值类型为number的 属性值集合
 * @param node dom节点
 * @param propNames dom的属性名集合
 * @returns dom的属性名、属性值 映射
 */
export const getNodeProps = (
  node: Element,
  props: INodePropCfg[],
): {
  [key: string]: string | number;
} => {
  if (!node) return {};
  if (!Array.isArray(props) || !props.length) return {};
  const computedStyle = getComputedStyle(node);
  return props.reduce((current, prop) => {
    const { name: propName, type: propType = 'string' } = prop || {};
    if (!propName) return current;
    let propValue: string | number = computedStyle.getPropertyValue(propName);
    if (propType === 'number') {
      propValue = Number.parseFloat(propValue);
      propValue = Number.isNaN(propValue) ? 0 : propValue;
    }
    return {
      ...current,
      [propName]: propValue,
    };
  }, {});
};
